__turbopack_context__.v({
  "root": "TemplatesSharingFilter-module__BzhMzG__root",
  "shared": "TemplatesSharingFilter-module__BzhMzG__shared",
});
